import { useEffect, useState } from 'react';
import {
  Collections_Enum,
  EmailTemplate,
} from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/email-template/v1/emailtemplate.pb';
import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { EmailTemplateQueries } from '@frontend/api-email-template';
import { DefaultTemplateCard, EmailTemplates, useEmailTemplates } from '@frontend/email-templates';
import { useBulkNavigator } from '../../hooks/use-bulk-navigator';
import { CONTAINER_HEIGHT } from './constants';

export const DefaultListTemplates = () => {
  const [pageToken, setPageToken] = useState<string | undefined>(undefined);
  const [templates, setTemplates] = useState<EmailTemplate[]>([]);

  const listRequest = { pageToken, collection: Collections_Enum.BULK_MESSAGING };

  const { data, fetchNextPage, hasNextPage, isFetched, isFetchingNextPage } =
    EmailTemplateQueries.useListSystemTemplates(listRequest);

  useEffect(() => {
    const newData = data?.pages?.[0]?.templates ?? [];
    const newTemplates = [...newData, ...templates];
    const filteredTemplates = newTemplates.filter(
      (template, index, arr) => arr.findIndex((t) => t.id === template.id) === index
    );
    setTemplates(filteredTemplates);
    return () => {
      setTemplates([]);
    };
  }, [pageToken, isFetched]);

  const getNextPage = () => {
    if (hasNextPage && !isFetchingNextPage) {
      setPageToken(data?.pages?.[0]?.nextPageToken);
      fetchNextPage();
    }
  };

  const navigateTo = useBulkNavigator(CampaignType.EMAIL);

  const { fetchSystemTemplate } = useEmailTemplates();

  const onTemplateClick = async (templateId?: string) => {
    if (!templateId) return;
    if (templateId) navigateTo.composer({ isSystemTemplate: true, templateId });
  };

  return (
    <EmailTemplates<EmailTemplate>
      DisplayedCard={(_index, template) => (
        <DefaultTemplateCard
          key={template.id}
          {...template}
          onTemplateClick={() => onTemplateClick(template.id)}
          onTemplateFetch={() => fetchSystemTemplate(template.id)}
        />
      )}
      getNextPage={getNextPage}
      hasNextPage={hasNextPage}
      height={CONTAINER_HEIGHT}
      isFetched={isFetched}
      isFetchingNextPage={isFetchingNextPage}
      templates={templates}
    />
  );
};
